import { render, staticRenderFns } from "./Acreditador.vue?vue&type=template&id=2f8b170a"
import script from "./Acreditador.vue?vue&type=script&lang=js"
export * from "./Acreditador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports